export function toggleSettings(currentState) {
    if (currentState == true) {
        return {type: "CLOSE_SETTINGS"};
    }
    return {type: "OPEN_SETTINGS"};
}

export function closeHistory() {
  return { type: "CLOSE_HISTORY" };
}

export function toggleHistory(currentState) {
    if (currentState == true) {
        return {type: "CLOSE_HISTORY"};
    }
    return {type: "OPEN_HISTORY"};
}

export function toggleInput(currentState) {
    switch (currentState) {
    case "SINGLE" :
        return {type: "SINGLE_INPUT"};

    case "MULTI" :
        return {type: "MULTI_INPUT"};

    default :
        return state
    }
}

export function toggleHistoryListType(currentState) {
    switch (currentState) {
    case "ALL" :
        return {type: "ALL_ENTRIES"};

    case "TODO" :
        return {type: "TODO_ENTRIES"};

    case "SUBMITTED" :
        return {type: "SUBMITTED_ENTRIES"};

    default :
        return state;
    }
}

export function toggleFavorites(currentState) {
    switch (currentState) {
    case "ACCOUNTS" :
        return {type: "SET_FAVORITES_ACCOUNTS"};

    case "PRODUCT_GROUPS" :
        return {type: "SET_FAVORITES_PRODUCT_GROUPS"};
    }
}

export function toggleDropDown(dropDown, currentState) {
    switch (dropDown) {
    case "LOCATION" :
        return {type: "TOGGLE_LOCATION", payload: !currentState};

    case "OPPORTUNITY" :
        return {type: "TOGGLE_OPPORTUNITY", payload: !currentState};

    case "HISTORY_VIEW_FILTER" :
        return {type: "TOGGLE_VIEW_FILTER", payload: !currentState};

    case "HISTORY_SORT_FILTER" :
        return {type: "TOGGLE_SORT_FILTER", payload: !currentState};

    case "HISTORY_ORDER_FILTER" :
        return {type: "TOGGLE_ORDER_FILTER", payload: !currentState};
    }
}

export function setHistoryFilter(dropDown, newValue) {
    switch (dropDown) {
    case "HISTORY_VIEW_FILTER" :
        return {type: "SET_VIEW", payload: newValue};

    case "HISTORY_SORT_FILTER" :
        return {type: "SET_SORT", payload: newValue};

    case "HISTORY_ORDER_FILTER" :
        return {type: "SET_ORDER", payload: newValue};
    }
}

export function modalController(currentModal, args={}) {
    switch (currentModal) {
    case "EDIT_FAVORITES" :
        return {type: "OPEN_EDIT_FAVORITES"};

    case "ADD_FAVORITES" :
        return {type: "OPEN_ADD_FAVORITES"};

    case "ACTIVITY" :
        return {type: "OPEN_ACTIVITY_CATEGORY"};

    case "ACCOUNT" :
        return {type: "OPEN_ACCOUNT"};

    case "PRODUCT_GROUP" :
        return {type: "OPEN_PRODUCT_GROUP"};

    case "WORKING_HOURS" :
        return {type: "OPEN_WORKING_HOURS"};

    case "ABOUT_TIME_TRACKER" :
        return {type: "OPEN_ABOUT_TIME_TRACKER"};

    case "REPORT_ERROR":
        return {type: "OPEN_REPORT_ERROR"};

    case "CLOSE_ALL" :
        return {type: "CLOSE_ALL"};

    case "SHOW_LOCATIONS_FROM":
        return {
            type: "SHOW_LOCATIONS_FROM",
            account: args.account
        };

    case "CLOSE_LOCATIONS":
        return {type: "CLOSE_LOCATIONS"};

    case "SHOW_OPPORTUNITIES_FOR":
        return {
            type: "SHOW_OPPORTUNITIES_FOR",
            account: args.account
        };

    case "CLOSE_OPPORTUNITIES":
        return {type: "CLOSE_OPPORTUNITIES"};

    case "DATE_FILTER_PICKER":
        return { type: "OPEN_DATE_FILTER_PICKER" };
    }
}



// WEBPACK FOOTER //
// ./app/actions/domActions.js